import { Route, Switch } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Alooma from 'services/alooma';
import useInitHotJar from 'services/useInitHotJar';
import useSetCjeInCookies from 'hooks/useSetCjeInCookies';
import useGoogleTagManager from 'hooks/useGoogleTagManager';
import { PATHS } from 'consts/paths';
import * as ALOOMA from 'consts/alooma';
import useProcessMarketingParamsOnPublicPage from 'hooks/useProcessMarketingParamsOnPublicPage';
import { Iframe } from 'components/pages/PartnershipsPage/PartnershipsPage.style';

const PartnershipsPage = () => {
  useInitHotJar();
  useSetCjeInCookies();
  useGoogleTagManager();
  useProcessMarketingParamsOnPublicPage();
  Alooma.usePageViewTracker();

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nocache" />
        <link rel="preconnect" href={PATHS.PARTNERSHIPS_EXTERNAL} />
      </Helmet>
      <Iframe title="Karma" src={PATHS.PARTNERSHIPS_EXTERNAL} allow="identity-credentials-get" frameBorder="0" />
    </>
  );
};

export const PartnershipsPageWithRoute = () => {
  return (
    <Switch>
      <Route
        path={[PATHS.PARTNERSHIPS_V2]}
        render={props => (
          <Alooma.SourceContext.Provider value={ALOOMA.SOURCE_PAGES.PARTNERSHIPS}>
            <PartnershipsPage {...props} />
          </Alooma.SourceContext.Provider>
        )}
      />
    </Switch>
  );
};
